import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BreadcrumbComponent as BreadcrumbComponent_1, DatalayerService, NotificationType, slugify } from '@woolworthsnz/styleguide';

export interface BreadcrumbItem {
	text: string;
	routeUrl?: string;
}

@Component({
	selector: 'recipe-breadcrumb',
	template: `
		<nav class="recipeBreadcrumb-container">
			<cdx-breadcrumb (clicked)="handleBreadcrumbClicked($event)"></cdx-breadcrumb>
		</nav>
	`,
	styleUrls: ['./breadcrumb.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [BreadcrumbComponent_1]
})
export class BreadcrumbComponent {
	constructor(private datalayerService: DatalayerService) { }

	handleBreadcrumbClicked(event: string): void {
		const slugifiedBreadrcumb = slugify(event);
		this.datalayerService.trackRecipeEvent(NotificationType.Link, `R_breadcrumb_${slugifiedBreadrcumb}`);
	}
}
